import { Http, HttpModule } from '@angular/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CookieModule } from 'ngx-cookie';
import { CoreModule } from './core/core.module';
import { LoginModule } from './login/login.module';
import { NgModule } from '@angular/core';
import { StompService } from 'ng2-stomp-service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoginLayoutComponent } from './core/layouts/login-layout.component';
import { PageLayoutComponent } from './core/layouts/page-layout.component';
import { ClaimComponent } from './claim/claim.component';
import { LetterComponent } from './letter/letter.componen';
import { DeductibleComponent } from './deductible/deductible.component';
import { MigratedSinesterComponent } from './migrated-sinester/migrated-sinester.component';
import { MigratedClaimComponent } from './migrated-claim/migrated-claim.component';
import { PrecargaSinDenunciaComponent } from './precarga-sin-denuncia/precarga-sin-denuncia.component';
import { DeductibleSinesterComponent } from './deductible/routeable/deductible-sinester/deductible-sinester.component';
import { NotificationRefreshService } from './core/services/notificationRefreshService';
export function HttpLoaderFactory(http: Http) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,

    BrowserAnimationsModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [Http]
      }
    }),

    CookieModule.forRoot(),

    CoreModule,
    LoginModule,

    // Routes get loaded in order.
    // It is important that AppRouting is Last as defines the catch-all ** route
    AppRoutingModule,

  ],
  exports: [],
  declarations: [AppComponent, LoginLayoutComponent, PageLayoutComponent, ClaimComponent, LetterComponent, DeductibleComponent, MigratedSinesterComponent, MigratedClaimComponent, PrecargaSinDenunciaComponent],
  providers: [StompService, NotificationRefreshService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/app.module.ts